<script>

    import {createEventDispatcher, onMount} from 'svelte';

    export let rent;

    const dispatch = createEventDispatcher();


    function modeConditional(arg, condition) {
        if (condition) {
            dispatch('mode', {
                data: arg
            });
        }
    }

    function mode(arg) {
        dispatch('mode', {
            data: arg
        });
    }

</script>


<main class="flex flex-row w-full flex-wrap drogowskazFont h-full justify-evenly">

    <div class="flex flex-row w-full">
        <div class="h-full w-2/4 flex flex-col bg-white text-center justify-center">
            <div>
                <br/>
            </div>
            <div>
                <img src="/logo.png"/>
            </div>
            <div>
                <br/>
            </div>
        </div>
        <div class="h-full w-2/4 flex flex-col bg-blue-1  text-center justify-center">
            <div>
                <span class="blue-3 text-xl">Witaj,</span>
            </div>
            <div>
                <span class="text-3xl blue-3">{rent.name1}</span>
            </div>
        </div>
    </div>

    <div class="flex flex-row w-full bg-blue-2 white text-white  text-base text-center justify-center py-4"
         on:click={() => mode('rentTime')}>
        <div class="w-1/4 text-center flex flex-col justify-center items-center">
            {#if rent.passed === true}
                <i class="fa fa-exclamation-triangle text-yellow-300 fa-3x"></i>
            {/if}
            {#if rent.passed === false}
                <i class="far fa-clock fa-3x blue-3"></i>
            {/if}
        </div>
        <div class="w-3/4 text-center justify-center flex flex-col">
            <span class="text-base">Koniec wynajmu:</span>


            {#if rent.passed === true}
                <span class="text-2xl">Już minął </span>
            {/if}
            {#if rent.passed === false}

                    <span class="text-2xl">
                        {#if rent.dayDiff > 0}

                            {#if rent.dayDiff === 1}
                                1 dzień
                            {/if}
                            {#if rent.dayDiff > 1}
                                {rent.dayDiff} dni
                            {/if}
                        {/if}

                        {#if rent.dayDiff < 3}

                            {#if rent.hourDiff === 1}
                                1 godzina
                            {/if}
                            {#if rent.hourDiff > 1 && rent.hourDiff < 5}
                                {rent.hourDiff} godziny
                            {/if}
                            {#if rent.hourDiff >= 5}
                                {rent.hourDiff} godzin
                            {/if}
                        {/if}
                    </span>
            {/if}
        </div>
    </div>

    <div class="flex flex-row w-full bg-blue-3 white text-white  text-base text-center justify-center py-4"
         on:click={() => mode('documents')}>
        <div class="w-1/4 text-center flex flex-col justify-center items-center">
            <i class="far fa-file-alt fa-3x blue-1"></i>
        </div>
        <div class="text-2xl w-3/4 flex flex-col justify-center items-center">
            <span>Dokumenty</span>
        </div>
    </div>

    <div class="flex flex-row w-full bg-blue-2 white text-white  text-base text-center justify-center py-4"
         on:click={() => modeConditional('payment', rent.paid < rent.price)}>
        <div class="w-1/4 text-center flex flex-col justify-center items-center">
            <!--            <i class="fas fa-dollar-sign fa-3x text-red-600"></i>-->
            <i class="fas fa-dollar-sign fa-3x blue-3"></i>
        </div>
        <div class="w-3/4 text-center justify-center flex flex-col">
            <span class="text-base">Cena: </span>
            <span class="text-2xl">{rent.price} PLN
                {#if rent.paid < rent.price}
                    <span class="text-red-500">(Nieopłacono)</span>
                {:else}
                    <span class="text-green-300">(Opłacono)</span>
                {/if}
            </span>
        </div>
    </div>

    <!--    <div class="flex flex-row w-full bg-blue-3 white text-white  text-base text-center justify-center py-4">-->
    <!--        <div class="w-1/4 text-center flex flex-col justify-center items-center">-->
    <!--            <i class="fas fa-file-invoice fa-3x blue-1"></i>-->
    <!--        </div>-->
    <!--        <div class="text-2xl w-3/4 flex flex-col justify-center items-center">-->
    <!--            <span>Faktura VAT</span>-->
    <!--        </div>-->
    <!--    </div>-->

    <!--    <div class="flex flex-row w-full bg-blue-2 white text-white  text-base text-center justify-center py-4">-->
    <!--        <div class="w-1/4 text-center flex flex-col justify-center items-center">-->
    <!--            <i class="fas fa-gas-pump fa-3x blue-3"></i>-->
    <!--        </div>-->
    <!--        <div class="text-2xl w-3/4 flex flex-col justify-center items-center">-->
    <!--            <span>Paliwo</span>-->
    <!--        </div>-->
    <!--    </div>-->

    {#if rent.invoiceType == 'INVOICE' || rent.invoiceType == 'RECEIPT'}
        <div class="flex flex-row w-full bg-blue-3 white text-white  text-base text-center justify-center py-4" on:click={() => mode('invoice')}>
            <div class="w-1/4 text-center flex flex-col justify-center items-center">
                <i class="fas fa-file-invoice-dollar fa-3x blue-1"></i>
            </div>
            <div class="text-2xl w-3/4 flex flex-col justify-center items-center">
                <span>Faktura VAT</span>
            </div>
        </div>
    {/if}

    <div class="flex flex-row w-full  white text-white  text-base text-center justify-center py-4"
         class:bg-blue-3={ rent.invoiceType !== 'INVOICE' && rent.invoiceType !== 'RECEIPT'}
         class:bg-blue-2={rent.invoiceType === 'INVOICE' || rent.invoiceType === 'RECEIPT'}>
        <div class="w-1/4 text-center flex flex-col justify-center items-center">
            <i class="fas fa-comments fa-3x blue-1"></i>
        </div>
        <div class="text-2xl w-3/4 flex flex-col justify-center items-center">
            <a target="_self" href="https://search.google.com/local/writereview?placeid=ChIJ6bfyjvlfGEcRsBAB-y5wO3Y">Opinia
                na
                Google Maps</a>
        </div>
    </div>
</main>
